import jwtDecode from 'jwt-decode'

export const state = () => ({
  token: null,
  name: null,
  email: null,
  phone: null,
  cpf: null,
  birthdate: null,
  validUntil: null,
  perfil: null,
})

export const getters = {
  isAuthenticated(currentState) {
    if (!currentState.token) {
      return false
    }
    if (!currentState.validUntil) {
      return true
    }
    const currentDate = new Date()
    return new Date(currentState.validUntil) > currentDate
  },
  isCoordinator(currentState) {
    return currentState.perfil === 'coordinator'
  },
  user(currentState) {
    return currentState
  },
}

export const mutations = {
  SET_CREDENTIALS(currentState, payload) {
    currentState.token = payload.token
    currentState.name = payload.name
    currentState.email = payload.email
    currentState.phone = payload.phone
    currentState.cpf = payload.cpf
    currentState.birthdate = payload.birthdate
    currentState.id = payload.id
    currentState.perfil = payload.pefil
    currentState.image = null
    // currentState.validUntil = payload.validUntil;
  },
  updateImage(currentState, newImageURL) {
    currentState.image = newImageURL
  },
}

export const actions = {
  setToken({ commit }, token) {
    const jwtJSON = jwtDecode(token)
    const {
      exp,
      user: { name, email, phone, cpf, birthdate, id, pefil, image } = {},
    } = jwtJSON

    const credentialData = {
      token,
      name,
      email,
      phone,
      cpf,
      birthdate,
      id,
      pefil,
      image,
      validUntil: exp > 0 ? new Date(exp * 1e3) : null,
    }

    // console.log()
    // if (credentialData.validUntil != null && new Date() > new Date(credentialData.validUntil)) {
    //   return;
    // }
    commit('SET_CREDENTIALS', credentialData)
    localStorage.token = token
    // this.$axios.setToken(token, 'Bearer');
    this.$axios.setHeader('Accept', 'application/json')
    this.$axios.setHeader('Authorization', `Bearer ${token}`)
    // this.$cookies.set('auth', token);
  },

  clearToken({ commit }) {
    commit('SET_CREDENTIALS', {
      token: null,
      name: null,
      email: null,
      phone: null,
      cpf: null,
      birthdate: null,
      validUntil: null,
      id: null,
      perfil: null,
      image: null,
    })
    this.$axios.setToken(null)
    localStorage.removeItem('token')
    localStorage.removeItem('classId')
    localStorage.removeItem('className')
    localStorage.removeItem('examDistribute')
    // this.$cookies.remove('auth');
  },
}
